import { render, staticRenderFns } from "./Kanban.vue?vue&type=template&id=53ca4796&scoped=true&lang=pug&"
import script from "./Kanban.vue?vue&type=script&lang=ts&"
export * from "./Kanban.vue?vue&type=script&lang=ts&"
import style0 from "./Kanban.vue?vue&type=style&index=0&id=53ca4796&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ca4796",
  null
  
)

export default component.exports